export enum CtvtVoltageLevel {
    Ratio_11000_110 = 1,
    Ratio_33000_110 = 2
}

export const CtvtVoltageLevelDisplay: Record<CtvtVoltageLevel, string> = {
    [CtvtVoltageLevel.Ratio_11000_110]: '11000/110',
    [CtvtVoltageLevel.Ratio_33000_110]: '33000/110'
};
